import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';

const Footer = () => {
  // Dinamik olarak mevcut yılı çeker (örn: 2026)
  const currentYear = new Date().getFullYear();

  return (
    <footer className='corporate-footer-container'>
        <div className='corporate-footer-inner'>
            <Link to='/kvkk' className='corporate-footer-link'>
              KVKK Aydınlatma Metni
            </Link>
            <p className='corporate-footer-text'>
              {currentYear} © ÖNDER Kariyer. Tüm Hakları Saklıdır.
            </p>
            <a href="mailto:insankaynaklari@onder.org.tr" className='corporate-footer-email'>
              insankaynaklari@onder.org.tr
            </a>
        </div>
    </footer>
  );
};

export default Footer;